<template>
  <tabbed-nav :tabs="tabs" />
</template>

<script>
import TabbedNav from '@/components/global/TabNav.vue';

export default {
  name: 'admin-nav',
  components: { TabbedNav },
  data() {
    return {
      tabs: [
        {
          title: 'Dashboard',
          route: 'admin',
          exact: true,
        },
        {
          title: 'Art Club',
          route: 'admin-studies',
        },
        // {
        //   title: 'Rewards',
        //   route: 'admin-rewards',
        // },
        {
          title: 'Users',
          route: 'admin-users',
        },
      ],
    };
  },
};
</script>
